import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Save, Clear } from '@material-ui/icons';
import Snackbar from "components/Snackbar/Snackbar.jsx";
import new_mail from "assets/img/new_mail.png"
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.jsx";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";
import Globales from "utils/Globales";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class ModalCancelarPedido extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {}
  }

  componentDidMount() { }

  handleCerrar = () => {
    // Cerrar modal
    if (this.props.eventClick) {
      this.props.eventClick(false);
    }
    
    // Redirección inteligente: verificar si viene del diseñador
    setTimeout(() => {
      const returnToDiseñador = localStorage.getItem("returnToDiseñador");
      if (returnToDiseñador === "true") {
        // Si viene del diseñador, redirigir al diseñador
        window.location.href = window.location.origin + "/diseñador3D";
      } else {
        // Si no viene del diseñador, redirigir a la página principal
        window.location.href = "/";
      }
    }, 100);
  }

  render() {
    const { classes, ...rest } = this.props;

    return (
      <div>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal
          }}
          open={this.props.Show}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleCerrar}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              simple
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              onClick={this.handleCerrar}
            >
              {" "}
              <Close className={classes.modalClose} />
            </Button>
            <h4 style={{ fontSize:"20px",marginBottom:"-25px" }}>Verificación de correo</h4>
          </DialogTitle>
          <DialogContent id="classic-modal-slide-description" className={classes.modalBody}>
            <div>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center",marginTop:"-25px" }}>
                <img src={new_mail} style={{ width: "150px", height: "150px" }} />
              </div>
              <span style={{ textAlign: "center", marginTop: "10px", display: "block" }}>
                Por favor, verifica tu correo electrónico para poder iniciar sesión. El correo fue enviado automáticamente por Auth0 cuando te registraste. Revisa tu bandeja de entrada y spam.
              </span>
            </div>
          </DialogContent>
          <DialogActions className={classes.modalFooter} style={{ justifyContent: "center" }}>
            <Button size="sm" color="github" round onClick={this.handleCerrar}>
              <Clear />&nbsp; Cerrar
            </Button>
          </DialogActions>
        </Dialog>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div >
    );
  }
}

export default withStyles(modalStyle)(ModalCancelarPedido);